import { Link } from "react-router-dom";

const Logo = ({ className }: { className?: string }) => {
  return (
    <Link 
      to="/"
      className={`flex items-center space-x-2 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-lg ${className}`}
      aria-label="Flexaura homepage - Navigate to main page"
    >
      {/* Circular Arc Icon */}
      <div className="relative w-8 h-8 flex items-center justify-center">
        <svg 
          viewBox="0 0 32 32" 
          fill="none" 
          className="w-full h-full"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="flexaura-logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#1B3A5C" />
              <stop offset="100%" stopColor="#C9973A" />
            </linearGradient>
            <mask id="crescent-mask">
              <rect width="32" height="32" fill="white"/>
              <circle cx="20" cy="12" r="8" fill="black"/>
            </mask>
          </defs>
          {/* Full circle with mask to create crescent */}
          <circle 
            cx="16" 
            cy="16" 
            r="12" 
            fill="url(#flexaura-logo-gradient)"
            mask="url(#crescent-mask)"
          />
        </svg>
      </div>
      
      {/* Navy text with gold accent */}
      <span className="text-2xl font-sans font-semibold text-primary">
        Flexaura
      </span>
    </Link>
  );
};

export default Logo;
